const SCHEME_NORMAL = 'normal';
const SCHEME_EXPAND = 'expand';

export { SCHEME_NORMAL, SCHEME_EXPAND };
